var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-centent",class:_vm.theme == 1 ? 'white' : 'black'})}
var staticRenderFns = []

export { render, staticRenderFns }